import { toast } from "sonner";
import { Copy, Smartphone } from "lucide-react";

export const AgentLoginLink = ({ slug }) => {
  if (!slug) return null;
  const url = `${window.location.origin}/agent?societe=${encodeURIComponent(slug)}`;
  const copy = () => navigator.clipboard?.writeText(url).then(() => toast.success("Lien copié"), () => window.prompt("Lien :", url));
  return (
    <div className="mb-5 flex flex-wrap items-center gap-x-4 gap-y-1 border border-slate-200 bg-slate-50 rounded-md px-3 py-2 text-xs" data-testid="agent-login-link">
      <span className="inline-flex items-center gap-1.5 font-bold text-slate-700"><Smartphone className="h-4 w-4 text-[#C9962E]" />Connexion des agents</span>
      <span>Code société : <b className="font-mono" data-testid="agent-login-company-code">{slug}</b></span>
      <span className="text-sky-700 break-all" data-testid="agent-login-url">{url}</span>
      <button type="button" onClick={copy} className="inline-flex items-center gap-1 font-semibold text-slate-700 hover:text-slate-900" data-testid="agent-login-link-copy"><Copy className="h-3.5 w-3.5" />Copier le lien</button>
    </div>
  );
};
